import { render, staticRenderFns } from "./CadastroCarroceria.vue?vue&type=template&id=5dd1ce42"
import script from "./CadastroCarroceria.vue?vue&type=script&lang=js"
export * from "./CadastroCarroceria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports